const isObject = (opt) => opt && typeof opt === 'object';

function getMessage(opt) {
  return isObject(opt) ? opt.message : opt;
}

// 用于业务流程异常和手动抛出异常
export class BusinessError extends Error {
  constructor(opt) {
    super(getMessage(opt));
    this.name = 'BusinessError';
    if (isObject(opt)) {
      this.requestOptions = opt.requestOptions;
      this.response = opt.response;
      if (opt.response && opt.response.data) {
        this.code = opt.response.data.code;
      }
    }
  }
}

// 用于网络请求错误
export class NetworkError extends Error {
  constructor(opt) {
    super(getMessage(opt));
    this.name = 'NetworkError';
    if (isObject(opt)) {
      this.requestOptions = opt.requestOptions;
      this.response = opt.response;
    }
  }
}

// 抛出异常，但不给用户提示，只记录相关埋点
export class SystemError extends Error {
  constructor(opt) {
    super(getMessage(opt));
    this.name = 'SystemError';
  }
}

// 抛出异常，给用户固定提示:'系统发生异常，请您稍后重试'，也记录埋点
export class NativeError extends Error {
  constructor(opt) {
    super(getMessage(opt));
    this.name = 'NativeError';
  }
}

// 只抛出异常，不发埋点，不给用户提示，用于中断流程
export class SilentError extends Error {
  constructor(opt) {
    super(getMessage(opt));
    this.name = 'SilentError';
    // 明确是否需要中断流程的标记
    this.break = opt && opt.break;
  }
}
